var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProductoAgricola(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 73.02,
    height: 83.673,
    viewBox: "0 0 73.02 83.673",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Seguro_Agr\\xEDcola",
    "data-name": "Seguro Agr\\xEDcola",
    transform: "translate(-912.5 -191.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_18999",
    "data-name": "Trazado 18999",
    d: "M935.7,199.6c0,3.924-7.1,14.2-7.1,14.2s-7.1-10.28-7.1-14.2a7.1,7.1,0,1,1,14.2,0Z",
    transform: "translate(20.408 0)",
    fill: "#95d4e9",
    stroke: "#0f265c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19000",
    "data-name": "Trazado 19000",
    d: "M923.6,197.5c3.924,0,14.2,7.1,14.2,7.1s-10.28,7.1-14.2,7.1a7.1,7.1,0,0,1,0-14.2Z",
    transform: "translate(7.653 12.755)",
    fill: "#95d4e9",
    stroke: "#0f265c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19001",
    "data-name": "Trazado 19001",
    d: "M921.5,214.7c0-3.924,7.1-14.2,7.1-14.2s7.1,10.28,7.1,14.2a7.1,7.1,0,1,1-14.2,0Z",
    transform: "translate(20.408 20.408)",
    fill: "#95d4e9",
    stroke: "#0f265c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19002",
    "data-name": "Trazado 19002",
    d: "M938.7,211.7c-3.924,0-14.2-7.1-14.2-7.1s10.28-7.1,14.2-7.1a7.1,7.1,0,1,1,0,14.2Z",
    transform: "translate(28.061 12.755)",
    fill: "#95d4e9",
    stroke: "#0f265c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19003",
    "data-name": "Trazado 19003",
    d: "M923.5,241.01c7.1-24.857,14.2-35.51,35.51-35.51C944.806,226.806,944.806,241.01,923.5,241.01Z",
    transform: "translate(25.51 33.163)",
    fill: "none",
    stroke: "#0f265c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19004",
    "data-name": "Trazado 19004",
    d: "M949.01,241.01c-7.1-24.857-14.2-35.51-35.51-35.51C927.7,226.806,927.7,241.01,949.01,241.01Z",
    transform: "translate(0 33.163)",
    fill: "none",
    stroke: "#0f265c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductoAgricola);
export default __webpack_public_path__ + "static/media/productoAgricola.4439eeb1159f3d283cfde75cd84d5dbe.svg";
export { ForwardRef as ReactComponent };